import React from "react";
import "../Style/_introduction.scss";

// =======================================================
// IntroductionCard class as Javascript function
// =======================================================
function IntroductionCard(props) {
  const { imagePath, title, text } = props; // Destructuring props

  return (
    <>
      <div className="introduction_card">
        {/* Image décorative : le titre de la carte suffit */}
        <img src={imagePath} alt="" loading="lazy" />
        <div className="card_text_container">
          <h4>
            <b>{title}</b>
          </h4>
          <p>{text}</p>
        </div>
      </div>
    </>
  );
}

export default IntroductionCard;
